import { Component, OnInit, Input, OnDestroy } from '@angular/core';
@Component({
    selector: 'text-widget',
    templateUrl: './textdisplay.component.html',
    styleUrls: ['./textdisplay.component.scss'],
    standalone: false
})
export class TextdisplayComponent implements OnInit {
	@Input('color') color: string;
  @Input('isListItem') isListItem: boolean;
  @Input('dashed') dashed: boolean;
  @Input('underlined') underlined: boolean;
  @Input('valueHidden') valueHidden: boolean=false;
  @Input('boxed') boxed: boolean;
  @Input('delayed') delayed : boolean;
  @Input('delayPlaceholder') delayPlaceholder : 'dots'|'dashes' = 'dots';
	@Input('text') set text(value: string){
    this._text = value;
    this.setup();
  }
  get text():string{
    return this._text;
  }
	textBefore:string;
	textAfter:string;
	icon:string;
  _hasIcon:boolean=false;
  _text :string = '';
  iconStrings : Array<string> = new Array<string>();
  textStrings : Array<string> = new Array<string>();
  
	constructor() { }
  @Input('focused') focused = false;
  getFirstIcon(){
    let rv = this.firstIcon + this.iconColor;
    //console.log("rv: "+rv);
    return rv;
  }
  getSecondIcon(){
    return this.secondIcon + this.iconColor;
  }
  
	getTextBeforeIcon(){
		return this.textBefore;
	}
	getTextAfterIcon(){
	  return this.textAfter;
	}
	getIcon(){
		return this.icon;
	}

	hasIcon(){
    return this._hasIcon;
	}
  lines(){
    let keyLines = 0;
    let key = this.getListItemKey();
    if(key && key.includes('\n')){
      keyLines = this.getListItemKey().split('\n').length;
    }else{
      keyLines = 1;
    }

    let valueLines = 0;
    let value = this.getListItemValue();

    if(value && value.includes('\n')){
      valueLines = value.split('\n').length;
    }
    if(valueLines > keyLines){
      return valueLines;
    }
    return keyLines;
  }
  get iconColor(){
    
    switch(this.color){
      case 'green':
      case '#00917E':{
        return 'Green';
      }
      case 'grey':
      case '#595959':{
        return 'Grey';
      }
      case 'darkGrey':
      case '#222222':{
        return 'Darkgrey';
      }
      case 'lightGrey':
      case '#7F7F7F':{
        return 'Lightgrey';
      }
      case 'white':
      default:{
        return '';
      }  
    }
    
  }
	getText(){
    if(this._text){
      return this._text;
    }else{
      return " ";
    }
	}
  iconCount=0;
  beforeFirstIcon="";
  firstIcon="";
  beforeSecondIcon="";
  secondIcon="";
  afterSecondIcon="";
  getListItemKey():string{
    return this.getText().split('|')[0];
  }
  getListItemValue():string{
    return this.getText().split('|')[1];
  }
  setup():void{
    let t = this._text;
    if(t == undefined){
      return;
    }
    this._hasIcon = false;
    this.iconStrings.length=0;
    this.textStrings.length=0;
    let currentText = null;
    let currentIcon = null;

    let obPos = t.indexOf('{{');
    if(obPos == -1){
       this.iconCount = 0;
       this.beforeFirstIcon = t;
       return;
    } 
    let cbPos = t.indexOf('}}');
    if(obPos >= 0){
      this.beforeFirstIcon = t.substring(0,obPos);
      this.firstIcon = t.substring(obPos+2,cbPos);
      this.iconCount = 1;
    }

    t = t.replace(t.substring(0,cbPos+2),'');

    obPos = t.indexOf('{{');
    cbPos = t.indexOf('}}');
    if(obPos == -1){
      this.beforeSecondIcon=t;
      return;
    }else{
      this.beforeSecondIcon= t.substr(0,obPos);
      
    }
    this.secondIcon=t.substring(obPos+2,cbPos);
    this.iconCount = 2;
    t=t.replace(t.substring(0,cbPos+2),'');
    this.afterSecondIcon=t;
  }
  oldSetup(){
    let beginPos = this._text.indexOf('{{');
    if(beginPos == -1){
      this._hasIcon = false;
      return;
    }else{
      let endPos = this._text.indexOf('}}');
      if(endPos == -1){
        this._hasIcon = false;      
        return;
      }
      this.textBefore = this._text.substring(0,beginPos);
      this.textAfter = this._text.substring(endPos+2,this._text.length);
      this.icon=this._text.substring(beginPos+2,endPos);
      this._hasIcon = true;
      return;
    }
  }

  
  delayTimer :any = undefined;
  ngOnInit() {
	  this.setup();
    
    if(this.isListItem && this.delayed){    
      this.valueHidden = true;
      this.delayTimer = setTimeout(()=>{
        this.valueHidden=false;
        this.delayTimer = null;
      },750);
    }

	}
	ngOnDestroy(){
    if(this.delayTimer){
      clearTimeout(this.delayTimer);
    }
	}
}
